import numeral from 'numeral';

export class MaxRangeValueConverter {
    toView(value) {
        return value == '99' ? 'Any' : value;
    }

    fromView(value) {
        return value.trim().toLowerCase() == 'any' ? 99 : value;
    }
}
